import styled from '@emotion/styled';
import { ModalBody } from 'components/Modals';
import { breakpoints } from 'app/spacing';
import { fontWeights } from 'app/typography';

export const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-y: auto; // Removes unnecessary scrollbar, which allows things to size/align per designs
  overflow-x: hidden;

  > button,
  > span {
    padding: 0;
    margin: 0;
    margin-bottom: 15px;
    &:empty {
      margin-bottom: 0;
    }

    font-weight: ${fontWeights.black};
    letter-spacing: 0.5px;
    border-width: 1px;
    line-height: 35px;
    height: 35px;

    width: 141px;
    @media (min-width: ${breakpoints.lg}px) {
      width: 180px;
    }
  }
`;

export const Wrapper = styled.div`
  flex: 1;
  margin-bottom: 17px;
`;
